import SSRIcon from "@ingka/ssr-icon";
import noticeRedSmall from "@ingka/ssr-icon/paths/notice-red-small";
import Text from "@ingka/text";

type Props = {
  message: string;
};

export function ValidationError({ message }: Props) {
  return (
    <div className="mr-space100 flex flex-row items-center">
      <SSRIcon aria-hidden paths={noticeRedSmall} className="mt-[0.3rem]" />
      <Text tagName="span" className="text-semantic-negative">
        {message}
      </Text>
    </div>
  );
}
